import { combineReducers } from 'redux';

import segmentsReducer from './biskoSegmentsThunk';
import propertiesReducer from './biskoPropertiesThunk';

export const biskoReducer = combineReducers({
    segments: segmentsReducer,
    properties: propertiesReducer,
});
